import packageJson from '../../package.json';

export const environment = {
  apiUrl: 'https://fb-tdlms.aakil.net',
  apiDocUrl: 'https://fb-tdlms.aakil.net',
  apiBioUrl: 'https://fb-tdlms.aakil.net',
  keycloakHost: 'https://fb-dkc.aakil.net',
  keycloak: {
    // Url of the Identity Provider
    issuer: 'https://fb-dkc.aakil.net/auth/realms/LMS',

    // URL of the SPA to redirect the user to after login
    redirectUri: 'https://fb-tdlms.aakil.net/',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-serverß
    clientId: 'web_app_tablet',

    responseType: 'code',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC.
    scope: 'openid profile email offline_access',
    // Remove the requirement of using Https to simplify the demo
    // THIS SHOULD NOT BE USED IN PRODUCTION
    // USE A CERTIFICATE FOR YOUR IDP
    // IN PRODUCTION
    requireHttps: true,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,

    // at_hash is not present in JWT token
    showDebugInformation: true,
    disableAtHashCheck: true,
  },
  enableDebug: true,
  enableNewLandingLayout: true,
  serviceWorker: true,
  production: false,
  showtrace: true,
  dummy_JSONs: false,
  showClientNotes: false,
  name: 'TABLET-DEV',
  useMdb5Adapted: true, // Toggle for rollback
  version: packageJson.version,
  showTribute: true
};
